import _map from 'lodash/map';
import React, { Component, PropTypes } from 'react';
import SocialIcon from '../social/SocialIcon';
import CircleOChevronRight from '../icons/CircleOChevronRight';

/**
 * Class representing the news subscription items
 *
 * Optional props:
 * subscriptionLinks
 *   - An array of objects specifying text and destination uri for the link
 *     E.g. [ { "text": "Sign up for weather alerts", "destinationUri: "" }, { ... }, ... ]
 *
 * socialMediaLinks
 *   - An array of objects specifying type and destination uri for the social link
 *     E.g. [ { "type": "facebook", "destinationUri: "" }, { ... }, ... ]
 *
 */
class SubscribeModule extends Component {
  static propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    subscriptionLinks: PropTypes.array,
    socialMediaLinks: PropTypes.array
  }

  render() {
    const {
      title = 'Follow us on social media',
      titleColor = '#000000',
      subscriptionLinks: subLinks = [],
      socialMediaLinks: mediaLinks = []
    } = this.props;

    return (
      <div className="SubscribeModule">
        {mediaLinks.length > 0 ?
          <div>
          <span style={{ color: titleColor }}>{title}</span>
            <div className="SubscribeModule-socialMediaIcons">
              {_map(mediaLinks, (mediaItem, i) =>
                mediaItem.type === 'email' ?
                <SocialIcon key={i} iconType={mediaItem.type} destinationUri={'mailto:' + mediaItem.destinationUri} noTarget />
                : <SocialIcon key={i} iconType={mediaItem.type} destinationUri={mediaItem.destinationUri} />)}
            </div>
          </div>
          : null}
        {_map(subLinks, (link, i) =>
          <div key={i} className="SubscribeModule-subscription">
            <a href={link.destinationUri} style={{ color: link.color }} target="_blank">
              <span className="SubscribeModule-linkText">{link.text}</span>
              <CircleOChevronRight />
            </a>
          </div>)}
      </div>
    );
  }
}

export default SubscribeModule;



// WEBPACK FOOTER //
// ./app/components/weather/SubscribeModule.js